





import { defineComponent } from '@vue/composition-api';
import InitialSession from '@/components/Question/InitialSession.vue';

const Initial = defineComponent({
  components: {
    InitialSession,
  },
  setup() {
    return {
      //
    };
  },
});

export default Initial;
